import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Logo({
  compact
}: {
  compact?: boolean;
}) {
  return <span className="flex items-center gap-2" data-id="element-893" data-mp="f7alwtemtr1u">
      <span className="grid h-8 w-8 shrink-0 -rotate-6 place-items-center rounded-xl bg-sun text-ink shadow-press" aria-hidden="true" data-id="element-894" data-mp="f8lo4osfiqqu">
        <CheckIcon className="h-5 w-5" strokeWidth={3.5} data-id="element-895" data-mp="6eqtwbsuikpz" />
      </span>
      <span className={`font-display font-semibold leading-none text-accent-ink ${compact ? 'text-sm' : 'text-base'}`} data-id="element-896" data-mp="1euoc84i2l8b">
        Do it, don't poo it
      </span>
    </span>;
}